<template>
    <div class="views-content--landing">

        <banner-generic :data="data.hero"></banner-generic>

        <!-- <div class="padding--lg">
            <element-text v-if="content.text" :data="content.text" />
        </div> -->

        <div class="padding--xl" :class="addedClassZero">
            <section>
                <div class="container">
                    <div class="row">
                        <div
                            class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                            v-for="(item, index) in data.items"
                            :key="index"
                        >
                        
                            <card class="image-landscape" :data="item" location="viewsContentLanding"></card>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- elements -->
        <div v-for="(element, index) in data.elements" :key="element.id">
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>

    </div>
</template>

<script>
    import viewsElementClasses from '../mixins/viewsElementClasses';
    import { BannerGeneric, Card} from "../components";

    // elements
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";

    export default {
        name: "v-landing",
        mixins: [viewsElementClasses],
        components: {
            BannerGeneric,
            Card,
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage,
            ElementForm
        },
        props: {
            data: {
                type: Object
            }
        }
    };
</script>
